import React from "react";
import { AlertTriangle } from "lucide-react";

export function ResourcePreview({ start, end, projectId, projects, dailyNeeds, month, editingEntryId }) {
  if (!start || !end || !month || start > end) return null;
  const project = projectId ? projects.find((p) => p.id === projectId) : null;
  const minPeople = parseInt(project?.min_people) || 0;
  const inRange = dailyNeeds.filter(({ day, isWeekend }) => {
    if (isWeekend) return false;
    const dstr = `${month}-${String(day).padStart(2, "0")}`;
    return dstr >= start && dstr <= end;
  });
  if (inRange.length === 0) return null;

  const overloaded = inRange.filter((d) => {
    const futureNeed = d.total + (editingEntryId ? 0 : minPeople);
    return futureNeed > d.available;
  });
  const ok = overloaded.length === 0;
  const minDeficit = ok ? 0 : Math.max(...overloaded.map((d) => (d.total + (editingEntryId ? 0 : minPeople)) - d.available));

  return (
    <div className={`rounded-md border p-3 text-sm ${ok ? "border-[#10B981] bg-[#D1FAE5]/30" : "border-[#F59E0B] bg-[#FEF3C7]/40"}`} data-testid="resource-preview">
      <div className="flex items-start gap-2">
        {ok ? (
          <span className="text-[#059669] font-bold mt-0.5">✓</span>
        ) : (
          <AlertTriangle size={16} className="text-[#D97706] mt-0.5 flex-shrink-0"/>
        )}
        <div className="flex-1">
          <div className={`font-semibold text-xs ${ok ? "text-[#059669]" : "text-[#D97706]"}`}>
            {ok
              ? `Resurse suficiente pe toată perioada${minPeople > 0 ? ` (proiect cere min. ${minPeople} oameni)` : ""}`
              : `Atenție: ${overloaded.length} zile cu deficit (max −${minDeficit} oameni)`}
          </div>
          {!ok && (
            <div className="text-[11px] text-zinc-600 mt-1 max-h-20 overflow-y-auto">
              {overloaded.slice(0, 6).map((d) => {
                const newTot = d.total + (editingEntryId ? 0 : minPeople);
                return (
                  <div key={d.day}>
                    Ziua <strong>{String(d.day).padStart(2,"0")}</strong>: necesar <strong>{newTot}</strong> · disponibili <strong>{d.available}</strong> → deficit <span className="text-[#DC2626] font-bold">−{newTot - d.available}</span>
                  </div>
                );
              })}
              {overloaded.length > 6 && <div className="text-zinc-500 italic">… și încă {overloaded.length - 6} zile</div>}
            </div>
          )}
          {minPeople === 0 && projectId && (
            <div className="text-[10px] text-zinc-500 mt-1">Proiectul nu are setat „minim necesar oameni" — completează în Proiecte pentru o estimare mai bună.</div>
          )}
        </div>
      </div>
    </div>
  );
}
